const popupComponent = (editor, componentOpts) => {
  const dc = editor.DomComponents;

  const popupComponentOptions = componentOpts.popup;
  const {
    name,
    type,
    mainAttribute,
    actualDisplayAttribute,
    overlayCloseAttribute
  } = popupComponentOptions;

  const popupContentStyles = componentOpts['popup-content'].style;

  const traitOpts = [{
      type: "text",
      name: "id",
      label: "ID",
      placeholder: "Enter id...",
    },
    {
      type: "select",
      name: overlayCloseAttribute,
      label: "Close Popup on Overlay click",
      options: [{
          name: "Yes",
          id: "yes"
        },
        {
          name: "No",
          id: "no"
        }
      ]
    }
  ];

  dc.addType(type, {
    isComponent: (el) =>
      el.tagName === "DIV" &&
      el.getAttribute(mainAttribute) === type,

    model: {
      defaults: {
        tagName: "div",
        draggable: true,
        droppable: true,
        attributes: {
          [mainAttribute]: type,
          "data-gjs-type": type,
          "data-gjs-name": name,
          [actualDisplayAttribute]: "block",
          [overlayCloseAttribute]: localStorage.getItem("engagement") == "VIFOR" ? "yes" : "no",
          id: "examplePopup",
          class: "noSwipe"
        },
        traits: traitOpts,
        components: [{
          type: "popup-content",
          style: popupContentStyles
        }],
      },

      init() {
        editor.on("component:styleUpdate:display", this.handleDisplayChange);
        this.set("__prev-display", this.getAttributes()[actualDisplayAttribute]);
      },

      removed() {
        editor.off("component:styleUpdate:display", this.handleDisplayChange);
      },

      handleDisplayChange(model) {
        if (model.is(type)) {
          let newDisplayValue = model.getStyle()?.display || "block";
          if (newDisplayValue !== "none") {
            model.addAttributes({
              [actualDisplayAttribute]: newDisplayValue
            });
          }
        }
      }
    },
  });

  editor.on("selector:add", (selector) => {
    if (selector.toString() === ".noSwipe") {
      selector.set({
        private: true
      });
    }
  });
};

export default popupComponent;